import { push } from 'redux-first-history';
import { routingOnRoute } from '.';
import { store } from '../../../store';
import { RoutingAction } from './types';

export const pushQuery = (toLocation: RoutingAction) => {
  return push({
    pathname: toLocation.path,
    search: toLocation.queryParams,
  });
};

export const getRouterLocation = () => {
  const state = store.getState();

  const { location } = state.router; // Adjust 'router' if you use a different key

  if (!location) {
    return {
      path: '',
      queryParams: '',
    };
  }

  const { pathname, search } = location;

  return {
    path: pathname,
    queryParams: search,
  };
};

export const getRoutingInfo = (toLocationPayload: RoutingAction) => {
  const fromLocationPayload = getRouterLocation();
  const routingInfo = {
    fromLocation: {
      path: fromLocationPayload.path,
      queryParams: fromLocationPayload.queryParams,
    },
    toLocation: {
      path: toLocationPayload.path,
      queryParams: toLocationPayload.queryParams ?? '',
    },
  };
  return routingInfo;
};

export const getRelevantActionByFromLocationPath = (
  fromPath: string,
  payload: RoutingAction,
) => {
  switch (fromPath) {
    default:
      return routingOnRoute(payload);
  }
};
